import icon3 from '../images/service/icon/a.jpg'
import icon2 from '../images/service/icon/ar.jpg'
import icon5 from '../images/service/icon/c.jpg'
import icon6 from '../images/service/icon/civ.jpg'
import icon1 from '../images/service/icon/co.jpg'
import icon4 from '../images/service/icon/g.jpg'

const serviceHome = [
  {
    Id: '01',
    Icon: icon2,
    // SImg: sSimg1,
    title: 'Exploration and Production',
    Subtitle: 'Exploration and Production',
    slug: 'exploration-production',
    description:
      'Identifying and extracting oil and gas reserves through onshore and oˬshore drilling operations.',
  },
  {
    Id: '02',
    Icon: icon1,
    // SImg: sSimg2,
    title: 'Refining and Processing',
    Subtitle: 'Refining and Processing',
    slug: 'Refining-Processing',
    description:
      'Advanced facilities for refining crude oil and processing gas',
  },
  {
    Id: '03',
    Icon: icon4,
    // SImg: sSimg3,
    title: 'Transportation and Logistics',
    Subtitle: 'Transportation and Logistics',
    slug: 'Transportation-Logistics',
    description:
      'Efficient logistics for the transportation of crude oil, refined products, and natural gas to markets worldwide.',
  },
  {
    Id: '04',
    Icon: icon3,
    // SImg: sSimg4,
    title: 'Diesel Supply',
    Subtitle: 'Diesel Supply',
    slug: 'Diesel-Supply',
    description:
      'Reliable diesel fuel supply for industrial and commercial use.',
  },
  {
    Id: '05',
    Icon: icon5,
    // SImg: sSimg5,
    title: 'Product Trading',
    Subtitle: 'Product Trading',
    slug: 'Product-Trading',
    description:
      'Trading a range of energy products across global markets.',
  },
  {
    Id: '06',
    Icon: icon6,
    // SImg: sSimg6,
    title: 'Environm ental M anagem ent',
    Subtitle: 'Environm ental M anagem ent',
    slug: 'Environm ental M anagem ent',
    description:
      'Best practices in environmental protection and remediation.',
  },
  // {
  //   Id: '07',
  //   Icon: icon7,
  //   // SImg: sSimg7,
  //   title: 'Custom Solutions',
  //   Subtitle: 'Custom Solutions',
  //   slug: 'Custom-Solutions-2',
  //   description:
  //     'Magnis lorem tinidunt eunamdictu mstlacus. Mattis risus vitae pretium viverra libero dapibus.',
  // },
  // {
  //   Id: '08',
  //   Icon: icon8,
  //   // SImg: sSimg8,
  //   title: 'Architectural Design',
  //   Subtitle: 'Architectural Design',
  //   slug: 'Architectural-Design',
  //   description:
  //     'Magnis lorem tinidunt eunamdictu mstlacus. Mattis risus vitae pretium viverra libero dapibus.',
  // },
  // {
  //   Id: '09',
  //   Icon: icon9,
  //   // SImg: sSimg9,
  //   title: 'Design & Planning',
  //   Subtitle: 'Design & Planning',
  //   slug: 'DesignPlanning21',
  //   description:
  //     'Magnis lorem tinidunt eunamdictu mstlacus. Mattis risus vitae pretium viverra libero dapibus.',
  // },
  // {
  //   Id: '10',
  //   Icon: icon10,
  //   // SImg: sSimg10,
  //   title: 'Power Managemnet',
  //   Subtitle: 'Power Managemnet',
  //   slug: 'Power-Managemnet22',
  //   description:
  //     'Magnis lorem tinidunt eunamdictu mstlacus. Mattis risus vitae pretium viverra libero dapibus.',
  // },

  // {
  //   Id: '11',
  //   Icon: icon11,
  //   // SImg: sSimg11,
  //   title: 'Urban Design',
  //   Subtitle: 'Urban Design',
  //   slug: 'Power-Managemnet23',
  //   description:
  //     'Magnis lorem tinidunt eunamdictu mstlacus. Mattis risus vitae pretium viverra libero dapibus.',
  // },
  // {
  //   Id: '12',
  //   Icon: icon12,
  //   // SImg: sSimg12,
  //   title: 'Environmental Planning',
  //   Subtitle: 'Environmental Planning',
  //   slug: 'Power-Managemnet24',
  //   description:
  //     'Magnis lorem tinidunt eunamdictu mstlacus. Mattis risus vitae pretium viverra libero dapibus.',
  // },
  // {
  //   Id: '13',
  //   Icon: icon13,
  //   // SImg: sSimg13,
  //   title: 'Community Engagement',
  //   Subtitle: 'Community Engagement',
  //   slug: 'Power-Managemnet25',
  //   description:
  //     'Magnis lorem tinidunt eunamdictu mstlacus. Mattis risus vitae pretium viverra libero dapibus.',
  // },
  // {
  //   Id: '14',
  //   Icon: icon14,
  //   // SImg: sSimg14,
  //   title: 'Master Planning',
  //   Subtitle: 'Master Planning',
  //   slug: 'Master-Planning',
  //   description:
  //     'Magnis lorem tinidunt eunamdictu mstlacus. Mattis risus vitae pretium viverra libero dapibus.',
  // },
  // {
  //   Id: '15',
  //   Icon: icon15,
  //   // SImg: sSimg15,
  //   title: 'Custom Solutions',
  //   Subtitle: 'Master Planning',
  //   slug: 'Master-Planning15',
  //   description:
  //     'Magnis lorem tinidunt eunamdictu mstlacus. Mattis risus vitae pretium viverra libero dapibus.',
  // },
  // {
  //   Id: '16',
  //   Icon: icon16,
  //   // SImg: sSimg16,
  //   title: 'House Renovation',
  //   Subtitle: 'Master Planning',
  //   slug: 'Master-Planning16',
  //   description:
  //     'Magnis lorem tinidunt eunamdictu mstlacus. Mattis risus vitae pretium viverra libero dapibus.',
  // },
  // {
  //   Id: '17',
  //   Icon: icon17,
  //   // SImg: sSimg17,
  //   title: 'General Contractor',
  //   Subtitle: 'Master Planning',
  //   slug: 'Master-Planning17',
  //   description:
  //     'Magnis lorem tinidunt eunamdictu mstlacus. Mattis risus vitae pretium viverra libero dapibus.',
  // },
  // {
  //   Id: '18',
  //   Icon: icon18,
  //   // SImg: sSimg18,
  //   title: 'City Landmarks',
  //   Subtitle: 'Master Planning',
  //   slug: 'Master-Planning18',
  //   description:
  //     'Magnis lorem tinidunt eunamdictu mstlacus. Mattis risus vitae pretium viverra libero dapibus.',
  // },
]

export default serviceHome
